import React, { ChangeEvent, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { useTheme } from 'styled-components';

import { Paragraph } from 'common/components';

export const UploadButton = ({
  acceptType,
  onChange,
}: {
  acceptType: string;
  onChange: (file: File) => void;
}) => {
  const { t } = useTranslation();
  const { fontFamily, colors } = useTheme();

  const [name, setName] = useState<string | null>(null);

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (!file) return;

    if (
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'application/vnd.ms-excel'
    ) {
      onChange(file);
      setName(file.name);
    }
  };

  return (
    <>
      <input
        type="file"
        accept={acceptType}
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <Button
        type="primary"
        onClick={handleClick}
        style={{ height: '2.5rem', width: '100%', marginTop: '1rem' }}
      >
        <Paragraph
          margin="0"
          fontFamily={fontFamily.semiBold}
          color={colors.white}
          fontSize="0.875rem"
          fontWeight="600"
        >
          {name || t('Upload document')}
        </Paragraph>
      </Button>
    </>
  );
};
